import { PolicyCoverageV2 } from "@hagerty/customer-insurance-gateway-client";

import { InsuranceOpsGetPolicyResponseCoverage } from "../../../types/responses";

export const compOnlyCoverageInsOps: InsuranceOpsGetPolicyResponseCoverage[] =
  [];
export const compOnlyCoverageCig: PolicyCoverageV2[] = [];

export const compOnlyExcessCoverageInsOps: InsuranceOpsGetPolicyResponseCoverage[] =
  [
    {
      Name: "Collision",
      Limit: "$0 Deductible",
      Type: 5023,
      Premium: 58,
      PolicyCoverageId: 894398082,
      CoverageGroup: "COLL",
      CoverageParentGroup: "COLL",
    },
  ];
export const compOnlyExcessCoverageCig: PolicyCoverageV2[] = [
  {
    name: "Collision",
    limit: "$0 Deductible",
    type: 5023,
  },
];

export const liabilityCoverageInsOps: InsuranceOpsGetPolicyResponseCoverage[] =
  [
    {
      Name: "Liability - BI",
      Limit: "$100000 / $300000",
      Type: 2,
      Premium: 79,
      PolicyCoverageId: 894398081,
      CoverageGroup: "BI",
      CoverageParentGroup: "LIAB",
    },
  ];
export const liabilityCoverageCig: PolicyCoverageV2[] = [
  {
    name: "Liability - BI",
    limit: "$100000 / $300000",
    type: 2,
  },
];
